export default __webpack_public_path__ + "static/media/DefaultPatient.813c2d94.jpg";